import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import 'thsc-hxmui/lib/style/index.css';

import TabsSegment from 'thsc-hxmui/lib/TabsSegment.js';
import 'thsc-hxmui/lib/style/TabsSegment.css';
import TabsSegmentPanel from 'thsc-hxmui/lib/TabsSegmentPanel.js';
import Button from 'thsc-hxmui/lib/Button.js';
import 'thsc-hxmui/lib/style/Button.css';
import Radio from 'thsc-hxmui/lib/Radio.js';
import 'thsc-hxmui/lib/style/Radio.css';
import Loading from 'thsc-hxmui/lib/Loading.js';
import 'thsc-hxmui/lib/style/Loading.css';
import Dialog from 'thsc-hxmui/lib/Dialog.js';
import 'thsc-hxmui/lib/style/Dialog.css';
import Popup from 'thsc-hxmui/lib/Popup.js';
import 'thsc-hxmui/lib/style/Popup.css';
import directives from 'thsc-hxmui/lib/directives.js';
Vue.use(TabsSegment).use(TabsSegmentPanel).use(Button).use(Radio).use(Loading).use(Dialog).use(Popup).use(directives);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
